import type { MediaDateGroup } from './types';
import { extractMediaFromMessage, groupByDate } from './utils';
import { useChannelContentSearch } from '../hooks/useChannelContentSearch';

const MEDIA_PAGE_LIMIT = 50;

export type { MediaItem, MediaDateGroup } from './types';

export function useChannelMedia() {
  const { data: groups, isLoading } = useChannelContentSearch<MediaDateGroup[]>({
    filter: { 'attachments.type': { $in: ['image', 'video'] } },
    searchOptions: { limit: MEDIA_PAGE_LIMIT, sort: { created_at: -1 } },
    transform: (messages) => groupByDate(messages.flatMap(extractMediaFromMessage)),
    initialData: [],
  });

  return { groups, isLoading };
}
